export const FIRST_NAMES = [
  'James',
  'Charlotte',
  'William',
  'Amelia',
  'Lachlan',
  'Isla',
  'Thomas',
  'Mia',
  'Henry',
  'Grace',
  'Oliver',
  'Chloe',
  'Hugh',
  'Matilda',
  'Angus',
  'Sophie',
  'Rohan',
  'Mei',
  'Nikolai',
  'Ana',
  'Kenji',
  'Fatima',
  'Luca',
  'Zara',
  'Callum',
  'Harriet',
  'Arjun',
  'Leila',
  'Patrick',
  'Ruby',
  'Daniel',
  'Ella',
  'Marcus',
  'Hannah',
  'George',
  'Lucy',
  'Vikram',
  'Yasmin',
  'Fraser',
  'Eleanor',
] as const;

export const LAST_NAMES = [
  'Ashworth',
  'Brennan',
  'Calloway',
  'Delaney',
  'Ellison',
  'Fitzgerald',
  'Galloway',
  'Hargreaves',
  'Iverson',
  'Jessop',
  'Kowalski',
  'Lindqvist',
  'Marchetti',
  'Nakamura',
  'Okonkwo',
  'Pemberton',
  'Quayle',
  'Rasmussen',
  'Sutherland',
  'Thornton',
  'Underwood',
  'Varga',
  'Whitfield',
  'Xu',
  'Yeoman',
  'Zielinski',
  'Abernethy',
  'Blackwood',
  'Castellano',
  'Drummond',
  'Everingham',
  'Faulkner',
  'Greaves',
  'Halloran',
  'Ingram',
  'Kavanagh',
  'Lombardi',
  'McAllister',
  'Novak',
  'Prescott',
] as const;

export const PLACES = [
  { suburb: 'Toorak', state: 'VIC', postcode: '3142' },
  { suburb: 'Brighton', state: 'VIC', postcode: '3186' },
  { suburb: 'Kew', state: 'VIC', postcode: '3101' },
  { suburb: 'Camberwell', state: 'VIC', postcode: '3124' },
  { suburb: 'South Yarra', state: 'VIC', postcode: '3141' },
  { suburb: 'Hawthorn', state: 'VIC', postcode: '3122' },
  { suburb: 'Malvern', state: 'VIC', postcode: '3144' },
  { suburb: 'Geelong', state: 'VIC', postcode: '3220' },
  { suburb: 'Ballarat', state: 'VIC', postcode: '3350' },
  { suburb: 'Mosman', state: 'NSW', postcode: '2088' },
  { suburb: 'Double Bay', state: 'NSW', postcode: '2028' },
  { suburb: 'Paddington', state: 'NSW', postcode: '2021' },
  { suburb: 'Ascot', state: 'QLD', postcode: '4007' },
  { suburb: 'New Farm', state: 'QLD', postcode: '4005' },
  { suburb: 'Cottesloe', state: 'WA', postcode: '6011' },
  { suburb: 'Unley', state: 'SA', postcode: '5061' },
  { suburb: 'Sandy Bay', state: 'TAS', postcode: '7005' },
] as const;

export const STREETS = [
  'Orrong Road',
  'Kooyong Road',
  'Church Street',
  'Glenferrie Road',
  'Wattletree Road',
  'Beach Road',
  'Cotham Road',
  'Military Road',
  'Ocean Street',
  'Sandgate Road',
  'Marine Parade',
  'King William Road',
] as const;

export const FOREIGN_PLACES = [
  { suburb: 'Auckland', state: 'AKL', postcode: '1010', country: 'NZ' },
  { suburb: 'Singapore', state: '', postcode: '238859', country: 'SG' },
  { suburb: 'Hong Kong', state: '', postcode: '', country: 'HK' },
  { suburb: 'London', state: '', postcode: 'SW1A 1AA', country: 'GB' },
  { suburb: 'San Francisco', state: 'CA', postcode: '94105', country: 'US' },
] as const;

export const ADVISERS = [
  'Meridian Private Wealth',
  'Southbank Family Office',
  'Laurel Advisory',
  'Harcourt & Lane Accountants',
] as const;

export const ACCOUNTANTS = [
  'Bayside Chartered Accountants',
  'Collins Street Tax Partners',
  'Northgate Advisory CA',
  'Riverside Accounting Group',
] as const;
